import {
    Alert,
    AlertDescription,
    AlertTitle,
} from "src/@/components/ui/alert"
import Iconify from "src/components/Iconify"

export function ZuiAlert({ title, description, icon, error, className }) {
    return (
        <Alert variant={error ? 'destructive' :'' } className={className}>
            {icon && <Iconify icon={icon} className="h-4 w-4" />}
            {title && <AlertTitle>{title}</AlertTitle>}
            {description && (
                <AlertDescription>
                    {description}
                </AlertDescription>
            )}

        </Alert>
    )
}
